import { css } from "styled-components";

// Shared by every modal: shrink the actions, never move one below the other.
export const modalActionStyles = css`
  .modal-footer {
    flex-wrap: nowrap;
    align-items: stretch;
  }

  .modal-footer > * {
    min-width: 0;
    margin: 0;
  }

  .modal-footer > button,
  .modal-footer > a {
    flex: 0 1 auto;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: center;
    line-height: 1.3;
  }

  @media (max-width: 576px) {
    .modal-footer {
      gap: 8px;
      padding: 12px;
    }

    .modal-footer > button,
    .modal-footer > a {
      flex: 1 1 0;
      padding: 9px 6px;
      font-size: clamp(11px, 3.2vw, 13px);
      min-height: 40px;
    }
  }
`;
